import React from 'react';
import { Slide } from 'pure-react-carousel';

type RenderSlideHtmlProps = {
  /** htmlItem is the html element to show */
  htmlItem: React.ReactNode;

  /** The array index number of this slide.  This same number is used in Dot, and thumbnail buttons
  to link them together.  For example, clicking on Dot 3 moves slide 3 into the leftmost
  slot in the Carousel viewport.  See pure-react-carousel documentation for more info.
  This number is generated automatically in Carousel. */
  i: number;

  /** a unique id for the carousel. This number is used to help create unique css id's and class
  names so that you can have more than one carousel on the page and style them differently,
  or reference a dom element via their unique id attribute name via javascript.
  This number is generated automatically in Carousel and passed in. */
  uid: number;
};

const RenderSlideHtml = ({ htmlItem, i, uid }: RenderSlideHtmlProps) => (
  <Slide
    aria-pressed={false}
    id={`carousel__slide--${uid}--${i}`}
    index={i}
    key={`carousel__slide--${uid}--${i}`}
    role="button"
    className="focus-on-modal-close"
  >
    <div>{htmlItem}</div>
  </Slide>
);

export default RenderSlideHtml;
